/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentCategoryDto } from '../../models/content-category-dto';
import { CreateContentCategoryDto } from '../../models/create-content-category-dto';

export interface AdminContentCategoryControllerCreate$Params {
      body: CreateContentCategoryDto
}

export function adminContentCategoryControllerCreate(http: HttpClient, rootUrl: string, params: AdminContentCategoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, adminContentCategoryControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentCategoryDto>;
    })
  );
}

adminContentCategoryControllerCreate.PATH = '/api/content-category/admin';
